import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { ReduxieService } from '../services/reduxieService';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { reducers } from './';
import { ApplicationState } from '.';
const dbname = 'hdlogstack';

const configureStore = (history: History, initialState?: ApplicationState) => {
  const middleware = [
    thunk,
    ReduxieService.middleware(['user', 'stacks']), // save user and stacks to indexedDB
    routerMiddleware(history),
  ];

  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history),
  });

  // eslint-disable-next-line no-console
  console.debug('initialState', initialState);

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware)),
  );
};

export { configureStore, dbname };
